module.exports = __webpack_public_path__ + "img/sh.714b3aa3.png";